import React, { useState, useCallback } from 'react';

// import './index.scss';

import { Segment, Bubble, Col, Row, Table } from 'tea-component';

import ExportTable from '@/pages/intelligence/components/ExportTable';
import { companiesStats } from '@intelligence/v3/constants/downloadLogPoint';

export default function DetailDownload(props: any) {
  const {
    downloadParamsNormal,
    downloadParamsOwn = {},
    segpaVa,
    companyName,
    mainLoading,
    gameName = '',
    dataSource,
    entityType,
    segment,
  } = props;

  //   下载需要的接口参数
  const getGenresReqParams = useCallback(() => {
    if (segpaVa == 'gamesOwned') {
      return {
        ...downloadParamsOwn,
        data_source: dataSource,
        region_type: 'market',
        regions: ['global'],
        entity_type: 'mobile',
        // start_date: "",
        // end_date: "",
        metrics: ['revenue', 'download'],
        period: 'month',
        order_metric: 'revenue',
        order: 'desc',
        check_metric: 'revenue',
        page: 1,
        page_size: 5,
        segpaVa,
        segment: 'All',
        device: [],
        gameName,
      };
    }
    return {
      ...downloadParamsNormal,
      segpaVa,
      segment: downloadParamsNormal?.segment || 'All',
      device: downloadParamsNormal?.device || [],
      gameName,
    };
  }, [downloadParamsNormal, downloadParamsOwn, segpaVa]);

  return (
    <ExportTable
      tableParams={getGenresReqParams()}
      businessType={'companies-detail'}
      isDisableDownload={mainLoading}
      isShowMaxDownloadRowsTips={false}
      downloadModalSize={820}
      // 这个total是假的 参考旧情报的固定的total
      total={9999999}
      // isDisableDataAmount={true}
      entityType={'companies'}
      excelName={companyName}
      segpaVa={segpaVa}
      dataSource={dataSource}
      downloadLogConfigKey={companiesStats?.[`${entityType}_${segment}`]}
    />
  );
}
